import { ComponentType } from 'react';
import { Box, Text } from '@backstage/ui';
import { NoResultDarkIcon, NoResultLightIcon } from '@xlrt/components';

import styles from './NoResultComponent.module.css';

interface NoResultsComponentProps {
  classes?: {
    emptyTabContainerClass?: string;
    emptyTabItemsClass?: string;
    emptyHeadingClass?: string;
    emptyDescriptionClass?: string;
  };
  emptyHeading?: string;
  emptyDescription?: string;
  /** The illustration for each theme; the active theme shows its own. */
  icons?: { light: ComponentType; dark: ComponentType };
}

const defaultIcons = { light: NoResultLightIcon, dark: NoResultDarkIcon };

const join = (...classNames: Array<string | undefined>) =>
  classNames.filter(Boolean).join(' ');

export const NoResultsComponent = ({
  classes: {
    emptyTabContainerClass,
    emptyTabItemsClass,
    emptyHeadingClass,
    emptyDescriptionClass,
  } = {},
  emptyHeading,
  emptyDescription,
  icons = defaultIcons,
}: NoResultsComponentProps) => {
  const { light: LightIcon, dark: DarkIcon } = icons;

  return (
    <Box className={join(styles.emptyTabContainer, emptyTabContainerClass)}>
      <Box className={join(styles.emptyTabItems, emptyTabItemsClass)}>
        <Box>
          <span className={styles.lightOnly}>
            <LightIcon />
          </span>
          <span className={styles.darkOnly}>
            <DarkIcon />
          </span>
        </Box>

        <Box className={styles.emptyDescription}>
          <Text
            as="p"
            className={join(styles.emptyDescriptionHeading, emptyHeadingClass)}
          >
            {emptyHeading || 'No Results Found'}
          </Text>
          <Text
            as="p"
            className={join(styles.emptyDescriptionBody, emptyDescriptionClass)}
          >
            {emptyDescription ||
              `It appears we don’t have any result that matches you search. Try
                different terms!`}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
